module.exports = __webpack_public_path__ + "media/images/CRM_logo-89feb48d076e01d96e2d2e5ad670a27b.png";